import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

import { useOrganizationContext } from "../../contexts/OrganizationContext";
import { useSessionContext } from "../../contexts/SessionContext";
import { useViewContext } from "../../contexts/ViewContext";
import { clinicLabel, isVisibleClinicRole } from "../../utils/clinicRoleOptions";
import { PrimaryButton } from "../common";
import { useNavigate } from "react-router-dom";

export default function ViewDialog() {
  const { setAccess, roles, inviteDialog } = useSessionContext();
  const navigate = useNavigate();
  const { organizationList } = useOrganizationContext();

  const { viewDialogIsOpen, setViewDialogIsOpen } = useViewContext();

  // Clínica da role fica de fora só se estiver convidada ou se a Organization
  // encontrada estiver explicitamente inativa (active === false).
  // organizationList começa undefined e a busca socio não usa os references
  // das roles: enquanto a lista não chega, ou se a busca não devolve a
  // organização, o vínculo da role continua visível.
  // Verificar se existem organizações ativas
  const hasActiveOrganizations = roles?.some((el: any) =>
    isVisibleClinicRole(el, organizationList)
  );


  function handleClose(event: any, reason: any) {
    if (reason && reason === "backdropClick") return;
    setViewDialogIsOpen(false);
  }

  function getRoles(data: any) {
    return [
      ...(data?.isManager ? ["manager"] : []),
      ...(data?.isPractitioner ? ["practitioner"] : []),
      ...(data?.isOwner ? ["owner"] : []),
      ...(data?.isInvited ? ["invited"] : []),
    ];
  }

  function handleProfessionalButton(organizationId: any, data: any) {
    localStorage.removeItem("warningsClosedOnce");
    setAccess({
      type: "professional",
      organizationId: organizationId,
      roles: getRoles(data),
    });
    localStorage.setItem("organizationId", organizationId);
    setViewDialogIsOpen(false);
    navigate("/");
  }

  async function handlePatientButton() {
    localStorage.removeItem("warningsClosedOnce");
    setAccess({ type: "patient" });
    setViewDialogIsOpen(false);
    navigate("/");
  }

  return (
    <Dialog
      onClose={handleClose}
      open={viewDialogIsOpen && !inviteDialog}
      maxWidth="sm"
      PaperProps={{
        sx: { borderRadius: "16px", paddingY: 4 },
      }}
    >
      <DialogTitle textAlign="center" mt={2}>
        {hasActiveOrganizations
          ? "Qual clínica deseja consultar?"
          : "Sem clínicas ativas"}
      </DialogTitle>
      <DialogActions>
        {hasActiveOrganizations ? (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            width="600px"
          >
            {roles
              ?.filter((el: any) => isVisibleClinicRole(el, organizationList))
              ?.map((item) => {
                // Alias só entra se existir. Sem organização na lista, usa o display da role.
                const label = clinicLabel(item, organizationList);

                return (
                  <Grid
                    item
                    xs={5}
                    key={`view-role-${
                      item.organization?.reference?.split("-")?.[1]
                    }`}
                  >
                    <PrimaryButton
                      height="68px"
                      width="100%"
                      onClick={() =>
                        handleProfessionalButton(
                          item.organization?.reference?.split("-")?.[1],
                          item
                        )
                      }
                    >
                      {label}
                    </PrimaryButton>
                  </Grid>
                );
              })}
          </Grid>
        ) : (
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={3}
            sx={{ px: 4, pb: 2 }}
          >
            <Grid item xs={12}>
              <Typography
                variant="body1"
                textAlign="center"
                color="neutral700.main"
              >
                Você não está associado a nenhuma clínica ativa no momento.
              </Typography>
            </Grid>
          </Grid>
        )}
      </DialogActions>

      <Typography
        variant="body1"
        textAlign="center"
        alignItems="baseline"
        mt={2}
        component="div"
      >
        Abrir
        <Button
          sx={{
            textTransform: "none",
            display: "inline",
            color: "primary",
          }}
          onClick={() => handlePatientButton()}
        >
          Visão do Paciente
        </Button>
      </Typography>
    </Dialog>
  );
}
